import { useState } from "react"
import { View, Text, Image } from "react-native"
import Feather from 'react-native-vector-icons/Feather'
import { API_URL } from "@env"

// Renders a coloured bubble with the entity's initials. Defensive by design:
// it must be impossible for this component to throw on ANY input — undefined,
// null, "", whitespace-only, or names with runs of spaces. Empty/whitespace
// names fall back to a neutral user glyph instead of crashing on
// `''.split(' ')[0].toUpperCase()`.
function GenericInitialProfilePicture({ name, style, textStyle }) {
    var palettes = ["rgba(45, 123, 196, 0.7)", "rgba(42, 201, 125, 0.7)", "rgba(232, 213, 90, 0.7)"]
    var num = 0

    // Coerce to a trimmed string, then collapse internal whitespace runs so
    // "John   Smith" / "  " / undefined all behave. trim() + split(/\s+/)
    // never produces empty parts for a non-empty trimmed value.
    var safe = (name == null ? "" : String(name)).trim()
    var parts = safe.length ? safe.split(/\s+/) : []

    var initials = ""
    for (var i = 0; i < parts.length; ++i) {
        var char = parts[i].charAt(0).toUpperCase()
        initials += char
        num += char.charCodeAt(0)
    }

    // num stays 0 for empty input → palettes[0]; never NaN/undefined.
    var color = palettes[num % palettes.length]

    if (!initials) {
        return (
            <View style={[{ backgroundColor: color, justifyContent: 'center', alignItems: 'center' }, style]}>
                <Feather name="user" size={20} color="white" />
            </View>
        )
    }

    return (
        <View style={[{ backgroundColor: color, justifyContent: 'center', alignItems: 'center' }, style]}>
            <Text style={[{ fontSize: 45, color: 'white', fontFamily: 'Arial, sans-serif', userSelect: 'none' }, textStyle]} allowFontScaling={false}>{initials}</Text>
        </View>
    )
}

function pictureUri(kind, userId, isProfilePicture) {
    // `kind === "firm"` → the firm-logo endpoint (served unauthenticated by the
    // mobile backend's `firm` blueprint, which is not dual-routed under /api).
    // Individual avatars use the user profile-picture endpoint — byte-identical
    // to the original happy path.
    if (kind === "firm") {
        return `${API_URL}/firm/${userId}/logo`
    }
    return `${API_URL}/api/user/${userId}/${isProfilePicture}/profile-picture`
}

export function ProfilePicture({ kind, isProfilePicture, userId, name, style, textStyle }) {
    // If a referenced image fails to load (deleted logo, 404, non-image mime),
    // fall back to the initials bubble so the avatar is never a blank hole.
    const [broken, setBroken] = useState(false)

    if (isProfilePicture && !broken) {
        return (
            <Image
                source={{ uri: pictureUri(kind, userId, isProfilePicture) }}
                style={style}
                onError={() => setBroken(true)}
            />
        )
    }

    return <GenericInitialProfilePicture name={name} style={style} textStyle={textStyle} />
}
